import React from 'react'
import {
  Typography,
  Container,
  createStyles,
  withStyles,
} from '@material-ui/core'

import { flexBreakpoint } from './styles'

const styles = (theme) => {
  return createStyles({
    section: {
      marginBottom: '5.4375rem',
    },
    container: {
      maxWidth: '70.9375rem',
      [theme.breakpoints.up(flexBreakpoint)]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row-reverse',
      },
    },
    body: {
      marginTop: '1rem',
      [theme.breakpoints.up(flexBreakpoint)]: {
        marginRight: '7.9375rem',
      },
    },
    title: {
      marginBottom: '2rem',
    },
  })
}

const Description = ({ classes, title, children, image, id }) => {
  return (
    <section className={classes.section} id={id}>
      <Container className={classes.container}>
        {image}
        <div className={classes.body}>
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
          <Typography>{children}</Typography>
        </div>
      </Container>
    </section>
  )
}

export default withStyles(styles)(Description)
